export default {
  menu: 'Costs',
  title: 'Costs',

  general: {
    paymentTypes: {
      cash: 'Receive cash',
      bank: 'Bank transfer',
      paymentGateway: 'Payment gateway or POS'
    },

    bankTypes: {
      pos: 'POS',
      card: 'card to card',
      sheba: 'IBAN'
    },

    types: {
      cash: 'Fund',
      bank: 'Bank',
      user: 'User cost',
      storeroom: 'Store',
      paymentGateway: 'Payment gateway',
      custom: 'Account cost'
    },

    labels: {
      all: 'All',
      type: 'Type',
      account: 'Cost headings',
      cash: 'payment from the fund',
      bank: 'Payment from the bank',
      payer: 'payer',
      paymentType: 'payment type',
      price: 'Amount',
      description: 'Description',
      date: 'Date of deposit',
      paymentFrom: 'Payment from',
      paymentTo: 'Payment to',
      maxPayment: 'Maximum payable',
      bankBalance: 'Bank balance',
      cashBoxBalance: 'Funds',
      userBalance: 'User balance'
    },

    placeholder: {
      date: 'Automatic'
    },

    table: {
      header: {
        restore: 'Restore',
        delete: 'Delete',
        price: 'Amount',
        account: 'Cost headings',
        payer: 'Account side',
        creator: 'Creator',
        date: 'Date',
        docNumber: 'Document number'
      }
    },

    notifications: {
      invalidAccount: 'Expenditure heading not selected',
      invalidCash: 'Inbox not selected',
      invalidBank: 'Bank not selected',
      invalidPrice: 'Amount is not valid',
      invalidPaymentType: 'Payment type not specified',
      invalidDescription: 'Expense description not entered',
      lowBalance: 'The balance of the bank or fund is not enough!',
      lowBalanceDynamicDate: 'The balance of the bank or fund in selected date is not enough!',
      incorrect_reference_id: 'reference id is not correct',

      insert: {
        success: 'Expense created successfully',
        error: 'Creating a cost was associated with an error'
      },
      delete: {
        success: 'Expense information successfully deleted',
        error: 'Deleting the cost information was accompanied by an error'
      },
      restore: {
        success: 'Expense information successfully restored',
        error: 'Restore the cost information was accompanied by an error'
      },
      print: {
        success: 'Your request has been sent, please wait',
        error: 'The print request has error'
      }
    },

    confirmations: {
      delete: {
        title: 'Confirm Delete cost',
        body: 'Are you sure you want to delete this cost completely?'
      }
    },

    validators: {
      dateHelp: 'The entry must be entered as {date}.',
      date: 'The deposit date is not entered correctly!',
      type: 'The payment type is not specified',
      price: 'The entered amount is more than the maximum amount that can be paid!',
      future: 'It is not possible to register a fee for the future',
      user: 'Payer not selected'
    }
  },

  insert: {
    title: 'New cost',

    suggests: {
      description: 'Received from {user} for {subject}'
    }
  },

  list: {
    title: 'Cost list'
  },

  trash: {
    title: 'Removed Cost List'
  },

  types: {
    title: 'Cost types list',

    general: {
      labels: {
        name: 'Title'
      },

      notifications: {
        insert: {
          success: 'The cost type was successfully created',
          error: 'create cost type has error'
        },

        edit: {
          success: 'The cost type was successfully updated',
          error: 'Update cost type has error'
        },

        delete: {
          success: 'Cost type deleted successfully',
          error: 'Deleting a cost type has error'
        },

        parseError: {
          parent: 'Parent heading not selected',
          name: 'Title not entered'
        }
      },

      confirmations: {
        delete: {
          title: 'Delete cost type',
          body: 'Are you sure you want to delete {name}?'
        }
      }
    },

    insert: {
      title: 'Add cost type'
    },

    edit: {
      title: 'Update cost type'
    }
  },

  document: {
    title: 'Cost',
    dynamicTitle: 'Expense number {docNumber}',

    labels: {
      payer: 'Payer / payers',
      account: 'Cost headings',
      details: 'Other information',
      creator: 'creator',
      date: 'Registration date',
      description: 'Description'
    }
  },

  logs: {
    title: 'Cost logs'
  }
}
